var style = {"article":"NpayDownloadButton-module_article__jl3DS","button":"NpayDownloadButton-module_button__-gLYq","point":"NpayDownloadButton-module_point__a5uBW","icon":"NpayDownloadButton-module_icon__QfpYU","app":"NpayDownloadButton-module_app__QyOax","download":"NpayDownloadButton-module_download__hozIT"};

export { style as default };
